
import { Button } from "@/components/ui/button"
import { useLocation } from "wouter"
import { ArrowLeft, Home } from "lucide-react"

export function NotFound() {
  const [, navigate] = useLocation()

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#0C1427] text-[#F6F6F6] p-4 text-center">
      <div className="space-y-6 max-w-md mx-auto">
        {/* Animated generic 404 text container */}
        <div className="relative">
          <h1 className="text-9xl font-black text-[#7846FF] opacity-20 select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <h2 className="text-4xl font-bold tracking-tight">
              Página não encontrada
            </h2>
          </div>
        </div>

        <p className="text-[#D1D1D1] text-lg">
          Desculpe, a página que você está procurando não existe ou foi removida temporariamente.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <Button 
              variant="outline" 
              onClick={() => window.history.back()}
              className="gap-2 border-[#15203c] bg-[#15203c] text-white hover:bg-[#15203c]/80 hover:text-white"
            >
              <ArrowLeft className="w-4 h-4" />
              Voltar
            </Button>

            <Button 
              onClick={() => navigate("/dashboard")}
              className="gap-2 bg-[#7846FF] hover:bg-[#7846FF]/90 text-white"
            >
              <Home className="w-4 h-4" />
              Ir para Dashboard
            </Button>
        </div>
      </div>

      {/* Footer minimalista */}
      <div className="absolute bottom-8 text-sm text-[#5D5D5D]">
        &copy; {new Date().getFullYear()} CineBlocks. Todos os direitos reservados.
      </div>
    </div>
  )
}
